// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorApiKeyRequests = (client) => ({
    /**
     * `POST /vendor/api-key-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateApiKeyRequest
     * @source apps/backend/src/api/vendor/api-key-requests/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/api-key-requests", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/api-key-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListApiKeyRequests
     * @source apps/backend/src/api/vendor/api-key-requests/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/api-key-requests", { method: "GET", query, headers }),
});
//# sourceMappingURL=api-key-requests.js.map